const ArchivoJudicial ={
    ObtenerDocumento: 'ArchivoJudicial/Documentos/GetDocumento',
    ObtenerParaReferencia: 'ArchivoJudicial/Inventario/GetDocumentoPorDatos',
    ObtenerVolumen: 'ArchivoJudicial/Inventario/GetVolumen',
    GuardarVolumen: 'ArchivoJudicial/Inventario/GuardaVolumen',
    GuardaDocumento: 'ArchivoJudicial/Inventario/GuardaDocumento',
    AgregarDocumento: 'ArchivoJudicial/Inventario/AgregaDocumento',
    HistoricosDeMovimientos: 'ArchivoJudicial/Historicos/Movimientos',
    HistoricosDeSolicitudes : 'ArchivoJudicial/Historicos/Solicitud',
    EnvioArchivo: 'ArchivoJudicial/Movimientos/EnviaDocumentoArchivo',
    EnvioJuzgado: 'ArchivoJudicial/Movimientos/EnviaDocumentoJuzgado',
    EnvioInterno: 'ArchivoJudicial/Movimientos/EnviaDocumentoInterno',
    EnvioPublico: 'ArchivoJudicial/Movimientos/EnviaDocumentoPublico',
    EnvioOtro: 'ArchivoJudicial/Movimientos/EnviaDocumentoOtro',
    ObtenerMovimiento: 'ArchivoJudicial/Movimientos/ObtenerMovimiento',
    GenerarListaInterna: 'ArchivoJudicial/Movimientos/GeneraListaInterna',
    GenerarListaTodos: 'ArchivoJudicial/Movimientos/GeneraListaTodos',
    RecepcionDocumento: 'ArchivoJudicial/Movimientos/RecepcionDocumento',
    InternoRecepcion: 'ArchivoJudicial/Movimientos/InternoRecepcion',
    TodosRecepcion: 'ArchivoJudicial/Movimientos/TodosRecepcion',
    ConsultaSolicitud : 'ArchivoJudicial/Solicitudes/ConsultaSolicitud',
    NuevaSolicitudInterna: 'ArchivoJudicial/Solicitudes/Interna',
    NuevaSolicitudPublicaArchivo: 'ArchivoJudicial/Solicitudes/PublicaArchivo',
    NuevaSolicitudPublicaJuzgado: 'ArchivoJudicial/Solicitudes/PublicaJuzgado',
    TodosSolicitudesPorVerificar : 'ArchivoJudicial/Solicitudes/PorVerificar',
    ArchivoSolicitudesPorVerificar : 'ArchivoJudicial/Solicitudes/ArchivoPorVerificar',
    PalacioSolicitudesPorVerificar : 'ArchivoJudicial/Solicitudes/PalacioPorVerificar',
    PenalSolicitudesPorVerificar : 'ArchivoJudicial/Solicitudes/PenalPorVerificar',
    TipoEstatusVolumen : 'ArchivoJudicial/Catalogos/GetTiposEstatusVolumen',
    TipoEstatusInventario : 'ArchivoJudicial/Catalogos/GetTipoEstatusInventario',
    NuevoDocumento : 'ArchivoJudicial/Inventario/NuevoDocumento',
    CambiaEstadoSolicitud : 'ArchivoJudicial/Solicitudes/CambioEstadoSolicitud',
    Conteo : 'ArchivoJudicial/Solicitudes/Conteo',
    DevolucionArchivo: 'ArchivoJudicial/Solicitudes/PorDevolucion',
    SolicitudesActivas: 'ArchivoJudicial/Solicitudes/SolicitudesActivas',
    ListadoDePublicos: 'ArchivoJudicial/Solicitudes/ListaPublicaJuzgado',
    ArchivoParaRecepcion: 'ArchivoJudicial/Movimientos/ArchivoRecepcion',
    TipoSedesArchivo: 'ArchivoJudicial/Catalogos/GetTipoSedeArchivo',
    GuardarSedeArchivo: 'ArchivoJudicial/SedesArchivo/GuardarSede',
    ListaSedesArchivo: 'ArchivoJudicial/SedesArchivo/GetListaSedes',
    TiposAreasExternas: 'ArchivoJudicial/Catalogos/GetTiposAreasExternas',
    ObtenerSede: 'ArchivoJudicial/SedesArchivo/GetSede',
    ListaDefinicionSedes: 'ArchivoJudicial/DefinicionSedes/ObtenerLista',
    GuardarDefinicion: 'ArchivoJudicial/DefinicionSedes/GuardaDefinicion',
    ObtenerDefinicion: 'ArchivoJudicial/DefinicionSedes/ObtenerDefinicion',
    ReporteNuevoIngreso: 'ArchivoJudicial/Reportes/NuevoIngreso',
    ReporteTotalIngresos: 'ArchivoJudicial/Reportes/TotalIngresoAreas',
    SolicitudesAnual: 'ArchivoJudicial/Reportes/TotalSolicitudes',
    UsuariosAnual: 'ArchivoJudicial/Reportes/TotalUsuarios',
    Referencia: 'ArchivoJudicial/Inventario/Referencia',
    TipoEstatusReferencia: 'ArchivoJudicial/Catalogos/GetTipoEstatusReferencia',
    ReportePublicasArchivo: 'ArchivoJudicial/Reportes/SolicitudesPublicas',
    AsignacionSede:'ArchivoJudicial/SedesArchivo/AgregaDefinicion',
    ReporteJuzgadosEnArchivo: 'ArchivoJudicial/Reportes/SolicitudesEnJuzgado',
    GuardarIncidente: 'ArchivoJudicial/Inventario/GuardaIncidente',
    GuardarListadoArchivo: 'ArchivoJudicial/Movimientos/GeneraListaArchivo',
    VerificarFechaListado: 'ArchivoJudicial/Movimientos/VerificarFechaListado',
    FechaListadoAcuerdo: 'ArchivoJudicial/Movimientos/ObtenerListaAcuerdo',
    EnvioSalaLectura: 'ArchivoJudicial/Movimientos/SalaLectura',
    RecepcionSala: 'ArchivoJudicial/Movimientos/RecepcionSalaLectura',
    RecepcionRegistro: 'ArchivoJudicial/Movimientos/RegistroPorCorrecion',
    AgregaTomos : 'ArchivoJudicial/Movimientos/AdicionTomos',
    ObtenerCaratula: 'ArchivoJudicial/Caratulas/CrearCaratulas',
    ObtenerLegajo: 'ArchivoJudicial/Caratulas/CrearLegajos',
    EliminarDeLista : 'ArchivoJudicial/Movimientos/EliminarListado',
    ObtenerDocumentosResguardo : 'ArchivoJudicial/Movimientos/ObtenerListaResguardo',
    EditarExternos : 'ArchivoJudicial/Historicos/EditaExternos',
    UpdateAnexos : 'ArchivoJudicial/Movimientos/ActualizaAnexos',
    RecepcionDevolucion : 'ArchivoJudicial/Movimientos/RecepcionArchivoDevolucion',
    RecepecionPrimeraVez : 'ArchivoJudicial/Movimientos/RecepcionDocumentoArchivoNuevos',
    ActualizarDocumento : 'ArchivoJudicial/Documentos/Actualizaciones',
    EliminaSolicitudHistorico : 'ArchivoJudicial/Historicos/EliminarSolicitud',
    EliminaListadoHistorico : 'ArchivoJudicial/Historicos/EliminarListado',
    CambiaFechaListado : 'ArchivoJudicial/Movimientos/CambiaFechaListado',
    EliminarDefinicion : 'ArchivoJudicial/SedesArchivo/EliminarDefinicion',
    EliminarUsuario : 'ArchivoJudicial/SedesArchivo/EliminarUsuario'
}

export default ArchivoJudicial



//////////////////
// WEBPACK FOOTER
// ./static/js/api/ArchivoJudicial/archivojudicialapi.js
// module id = null
// module chunks = 